module.exports = __webpack_public_path__ + "static/wallers-29b480d8f2902164a74406e639ccae91.webm";